module.exports = __webpack_public_path__ + "img/hadron-collider.4e5c6a33.png";